import { render, staticRenderFns } from "./PessoaAbas.vue?vue&type=template&id=1157143d&"
import script from "./PessoaAbas.vue?vue&type=script&lang=js&"
export * from "./PessoaAbas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports